var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{staticClass:"standby_lnfo"},[_c('v-card-text',[_c('p',[_vm._v(" "+_vm._s(_vm.outOfServiceTxt)+" ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }